import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin( ScrollTrigger );

gsap.from(".gsap-featured-img", {
    scrollTrigger: {
        toggleActions: "play none reverse none",
        trigger: ".gsap-featured-img",
        start: 'top bottom',
        end: 'top center',
        markers: false,
        scrub: true,
    },
    y: '300',
});

gsap.from(".gsap-featured-content", {
    scrollTrigger: {
        toggleActions: "play none reverse none",
        trigger: ".gsap-featured-content",
        start: 'top bottom',
        end: 'top +=60%',
        markers: false,
        scrub: true,
    },
    y: '100%',
});